import { DatePicker, Flex, Table } from 'antd'
import { useState } from 'react'

import { useTreatmentServiceGetListPatientNewbornsEndpoint } from 'src/api/queries'
import { NewBornStatus } from 'src/api/requests'
import { PageBreadcrumbs, Select } from 'src/components'
import { useNewBornColumns } from 'src/features/persons/components/PregnancyMonitoring/hooks/useNewBornColumns'
import { useTablePagination, useUser, useDefaultSortingItem } from 'src/hooks'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'
import { resetPagination } from 'src/utils'

export const InstitutionPregnancyNewBorns = () => {
  const { t } = useLocales()

  const { userData } = useUser()
  const pagination = useTablePagination()

  const { columns } = useNewBornColumns()

  const [birthDate, setBirthDate] = useState<string[]>([])
  const [status, setStatus] = useState('')

  const { defaultSortingOption } = useDefaultSortingItem()

  const queryParams = {
    pageNumber: pagination.current,
    pageSize: pagination.pageSize,
    institutionIds: [String(userData?.currentLegalEntityId)],
    ...(birthDate?.[0] &&
      birthDate?.[1] && {
        birthDateFrom: birthDate?.[0],
        birthDateTo: birthDate?.[1]
      }),
    ...(status && { status: [status] as NewBornStatus[] })
  }

  const { data, isLoading } =
    useTreatmentServiceGetListPatientNewbornsEndpoint(queryParams)

  const onSelect = (val: string) => {
    setStatus(val)
    resetPagination(pagination)
  }

  const onBirthDateSelect = (val: string[]) => {
    setBirthDate(val)
    resetPagination(pagination)
  }

  const newBornStatusOptions = [
    defaultSortingOption,
    ...Object.values(NewBornStatus).map((item) => ({
      value: item,
      label: t(`pregnancy.newborn_statuses.${item}`)
    }))
  ]

  return (
    <PageBreadcrumbs
      items={[{ title: t('persons.person_pregnancy') }]}
      title={t('pregnancy.newBorns')}
    >
      <Flex vertical gap={16}>
        <Flex gap={8}>
          <DatePicker.RangePicker
            onChange={(_, dateStrings) => onBirthDateSelect(dateStrings)}
            format={dayMonthYearBackSlash}
            placeholder={[
              t('pregnancy.birth_date_from'),
              t('pregnancy.birth_date_to')
            ]}
          />

          <Select
            onSelect={onSelect}
            placeholder={t('pregnancy.newborn_status')}
            options={newBornStatusOptions}
          />
        </Flex>

        <Table
          rowKey="id"
          scroll={{ x: 'max-content' }}
          loading={isLoading}
          columns={columns}
          dataSource={data?.data}
          pagination={{ ...pagination, total: data?.totalCount }}
        />
      </Flex>
    </PageBreadcrumbs>
  )
}
